import { BlockContent } from "@lib/sanity-components";
import { SanityFAQItem } from "@sourceful/shared-types";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { accordionStyles } from "./accordionStyles";

export interface FAQProps {
  faqItems: SanityFAQItem[];
  accordionProps?: {
    className?: string;
    preExpanded?: string[];
    allowMultipleExpanded?: boolean;
    allowZeroExpanded?: boolean;
    onChange?(args: string[]): void;
  };
}

const FAQ = ({ faqItems, accordionProps }: FAQProps) => {
  return (
    <Accordion allowZeroExpanded className={accordionStyles()} {...accordionProps}>
      {faqItems.map(item => {
        return (
          <AccordionItem key={item._id}>
            <AccordionItemHeading>
              <AccordionItemButton>{item.title}</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <BlockContent value={item.content} />
            </AccordionItemPanel>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
};

export default FAQ;
